var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "m390 135c4 4 5 8 2 13l-166 356c-3 5-7 8-13 8-1 0-2 0-4-1-4-1-6-3-8-5-2-3-2-6-1-10l60-248-125 31c0 0-2 0-3 0-4 0-7-1-10-3-4-3-5-7-4-12l62-254c1-3 2-5 5-7 2-2 5-3 8-3l101 0c4 0 8 1 10 4 3 2 4 5 4 9 0 2 0 3-1 5l-53 143 122-30c2-1 3-1 4-1 4 0 7 2 10 5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElec);
export default __webpack_public_path__ + "static/media/elec.3efc822b.svg";
export { ForwardRef as ReactComponent };